import config from '../../../config';
import Request from '../../Request';

export default function index(options, onSuccess, onFailure) {
  const { status, sortBy, startAt, endAt } = options;
  return Request.get(
    `${config.apiUrl}/reservations?status=${status}&sort_by=${sortBy}&start_at=${startAt}&end_at=${endAt}`,
    onSuccess,
    onFailure
  );
}